var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmpleHireLoaderBoundryCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 69.5,
    fill: "url(#paint0_linear_267_2)",
    stroke: "#B08F4B",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_267_2",
    x1: 43,
    y1: 11,
    x2: 98,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmpleHireLoaderBoundryCircle);
export default __webpack_public_path__ + "static/media/ample-hire-loader-boundry-circle.2fd353f017ed1cf2416b0f4fce6ece85.svg";
export { ForwardRef as ReactComponent };